<template>
	<SectionContainer
		ref="sectionContainer"
		:isExpandable="true"
		class="company-oems"
	>
		<template #left>
			<h4>OEMS</h4>
		</template>
		<template #right>
			<div v-if="editMode">
				<Button
					className="btn--icon-only"
					iconClassName="icon-more"
					:iconBeforeLabel="true"
				/>
				<Button
					className="btn--icon-only"
					iconClassName="icon-unsaved"
					:iconBeforeLabel="true"
				/>
				<Button
					className="btn--icon-only"
					iconClassName="icon-close"
					:iconBeforeLabel="true"
					:btnClick="handleEditMode"
				/>
			</div>
			<Button
				v-if="!editMode"
				className="btn--icon-only"
				iconClassName="icon-edit"
				:iconBeforeLabel="true"
				:btnClick="handleEditMode"
			/>
		</template>
		<template #content>
			<!-- DEV NOTE: HorizontalScrolling component is not working at the moment. Update this piece after is ready -->
			<!-- <HorizontalScrolling
				:source="carouselSource"
				:component="carouselComponent"
			/> -->
			<!-- TO BE REMOVE: remove when HorizontalScrolling component is fixed -->
			<ul class="company-oems__items" v-if="!editMode">
				<li v-for="(item, index) in carouselSource.items" :key="index">
					<CompanyOEMSCard :item="item" />
				</li>
			</ul>
			<ul class="company-oems__items-edit-mode" v-else>
				<li v-for="(item, index) in carouselSource.items" :key="index">
					<CompanyOEMSCardEdit
						v-model="carouselSource.items[index]"
					/>
				</li>
			</ul>
			<Modal
				:display="true"
				:isConfirmation="true"
				v-if="closeWithOutSaving"
			>
				<template #modal-content>
					Are you sure you want to close this section without saving?
				</template>
			</Modal>
		</template>
	</SectionContainer>
</template>

<script>
import SectionContainer from '@/components/shells/section-container/section-container';
import Button from '@/components/forms/button/button';
import Modal from '@/components/shells/modal/modals';
// import HorizontalScrolling from '@/components/shells/horizontal-scrolling/horizontal-scrolling';
import CompanyOEMSCard from './company-oems-card.vue';
import CompanyOEMSCardEdit from './company-oems-card-edit.vue';
import _ from 'lodash';

export default {
	name: 'CompanyOEMS',
	components: {
		SectionContainer,
		Button,
		Modal,
		CompanyOEMSCard, //comment when HorizontalScrolling is ready
		//HorizontalScrolling
		CompanyOEMSCardEdit
	},
	props: {
		data: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			carouselSource: {
				totalPageCount: 1,
				countPerPage: this.data.length,
				items: _.cloneDeep(this.data),
				totalCount: this.data.length,
				page: 1
			},
			carouselComponent: CompanyOEMSCard,
			closeWithOutSaving: false,
			editMode: false
		};
	},
	methods: {
		handleEditMode() {
			this.editMode = !this.editMode;
		}
	},
	watch: {
		'carouselSource.items': {
			deep: true,
			handler(newValue) {
				console.log(newValue);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.company-oems {
	&__items,
	&__items-edit-mode {
		display: flex;
		gap: $gutter-md;
	}

	h4 {
		margin-block-start: 0;
		margin-block-end: 0;
	}
}
</style>
